import a from "./index.es63.js";
var x = a, C = u;
function u(f) {
  if (f >= 55296 && f <= 57343 || f > 1114111)
    return "�";
  f in x && (f = x[f]);
  var r = "";
  return f > 65535 && (f -= 65536, r += String.fromCharCode(f >>> 10 & 1023 | 55296), f = 56320 | f & 1023), r += String.fromCharCode(f), r;
}
export {
  C as d
};
//# sourceMappingURL=index.es42.js.map
